module.exports = __webpack_public_path__ + "media/components/greenroom-articles/static/icon-caret-left-643db14926bd76618b29f7781c126405.svg";